import React from "react"
import { HStack, chakra } from "@chakra-ui/react"

type Props<T extends string> = {
  value: T
  onChange: (value: T) => void
  options: { value: T, label: string }[]
}

// Same look as the preview-device toggle (components/elements/DeviceToggle).
const SegmentedControl = <T extends string>({ value, onChange, options }: Props<T>) => (
  <HStack
    role="group"
    spacing="2px"
    h={8}
    p="2px"
    borderWidth={1}
    borderColor="gray.200"
    borderRadius="10px"
    flexShrink={0}
  >
    {options.map((option) => {
      const selected = option.value === value

      return (
        <chakra.button
          key={option.value}
          type="button"
          aria-pressed={selected}
          onClick={() => onChange(option.value)}
          h="26px"
          px={3}
          borderRadius="7px"
          fontSize="xs"
          fontWeight="semibold"
          color={selected ? "gray.900" : "gray.600"}
          bg={selected ? "gray.100" : "transparent"}
          _hover={{ bg: "gray.100", color: "gray.900" }}
        >
          {option.label}
        </chakra.button>
      )
    })}
  </HStack>
)

export default SegmentedControl
